exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#customers[data-v-4d0d5fc7]{font-family:Trebuchet MS,Arial,Helvetica,sans-serif;border-collapse:collapse;width:100%}#customers td[data-v-4d0d5fc7],#customers th[data-v-4d0d5fc7]{border:2px solid #ddd;text-align:left;width:1%;white-space:nowrap}#customers tr[data-v-4d0d5fc7]:nth-child(2n){background-color:#f2f2f2}#customers tr[data-v-4d0d5fc7]:hover{background-color:#ddd}#customers th[data-v-4d0d5fc7]{padding-top:12px;padding-bottom:12px;text-align:center;background-color:#595a59;color:#fff}#auto[data-v-4d0d5fc7]{overflow-x:auto;width:100%}.anim[data-v-4d0d5fc7]{width:150px}.numFont[data-v-4d0d5fc7]{font-size:12px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4d0d5fc7","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/procurement/voucher/finance_voucher_form.vue
// module id = 1452
// module chunks = 3